import React, { Component } from 'react';
import { connect } from 'react-redux';
import MyAccountWrapper from './style';
import basicStyle from '../../config/basicStyle';
import appActions from '../../redux/itunesSearch/actions';
const { appSelected, searchTermUpdated } = appActions;
import { bindActionCreators } from 'redux'
import { Row, Col } from 'antd';
import ContentHolder from '../../components/utility/contentHolder';
import Dropdowns, {
  DropdownButtons,
  DropdownMenu,
  MenuItem,
  SubMenu
} from '../../components/uielements/dropdown';
import { Icon } from 'antd';
import { Formik, FieldArray } from 'formik';
import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/rrui.css'
import 'react-phone-number-input/style.css'

class MyAccount extends Component {

  constructor(props) {
    super(props);
    this.state = {
      primaryContactEditable: false,
      changePassword: false,
      profile: null
    };

    if (props && props.auth)
      props.auth.getProfile( function (err, profile) {
        this.setState({ profile: profile });
        console.log(this.state.profile);
      }.bind(this));
    
    this.onClickPrimaryContactEdit = this.onClickPrimaryContactEdit.bind(this);
    this.onClickChangePassword = this.onClickChangePassword.bind(this);
  }
  
  componentWillUpdate(){
    console.log( ' componentWillUpdate')
    //check difference
    
  }
  componentWillReceiveProps(){
    console.log( ' componentWillReceiveProps')
  }

  

  createCampaignFake(campaign){
  }

  onClickPrimaryContactEdit() {
    this.setState({
      primaryContactEditable: !this.state.primaryContactEditable
    });
  }

  onClickChangePassword() {
    this.setState({
      changePassword: !this.state.changePassword
    });
  }

  render() {
    // console.log( this.props)
    // const { appDetail } = this.state;
    // const { searchTerm, campaign, currentApp, secondApp} = this.props;    
    const { rowStyle, colStyle } = basicStyle;

    return (
      <MyAccountWrapper>
        <div className="account-menu">
          <ul>
            <li>
              <a href="account" className="active">我的帐户</a>
            </li>
            
            <li>
              <a href="billing">付款资料</a>
            </li>
          </ul>
        </div>

        <div className="main">
          <div className="info">
            <h2>
              <span>我的帐户资料</span>
              {this.state.changePassword ? null :
                <a href="javascript:void(0)" onClick={this.onClickChangePassword}>更改密码</a>
              }
            </h2>
            <Formik
              initialValues={{password: '*********'}}
              validate={values=>{}}
              onSubmit={values=>{
                console.log('change password')
                console.table(values)
                this.setState({
                  changePassword: false
                })
              }}
              render={({ handleSubmit, handleChange, handleBlur, setFieldValue, values, errors, dirty, touched}) => {
                return (
                  <form onSubmit={handleSubmit}>
                    <Row style={rowStyle}>
                      <Col md={12} sm={24} xs={24} style={colStyle}>
                          <dt>帐号</dt>
                      </Col>
                      <Col md={12} sm={24} xs={24} style={colStyle}>
                        <dd>
                          <span className="bill-attn-to">
                            {this.state.profile && this.state.profile.email}
                          </span>
                        </dd>
                      </Col>
                    </Row>

                    <Row style={rowStyle}>
                      <Col md={12} sm={24} xs={24} style={colStyle}>
                          <dt>密码</dt>
                      </Col>
                      <Col md={12} sm={24} xs={24} style={colStyle}>
                        <ContentHolder>
                          <div className="inputWrapper">
                            <div className={`FormTextInput ${!this.state.changePassword ? "noteditable" : ""}`}>
                                {/* <span className="bill-attn-to">{values.password}</span> */}
                                <input disabled={!this.state.changePassword} type="password" name="password" value={values.password}/>
                            </div>
                          </div>
                        </ContentHolder>
                      </Col>
                    </Row>
                    
                    {this.state.changePassword ? (
                      <Row style={rowStyle}>
                        <Col md={12} sm={24} xs={24} style={colStyle}>
                            <dt>确认密码</dt>
                        </Col>
                        <Col md={12} sm={24} xs={24} style={colStyle}>
                          <ContentHolder>
                            <div className="inputWrapper">
                              <div className={`FormTextInput ${!this.state.changePassword ? "noteditable" : ""}`}>
                                  <input type="password" name="confirmPassword"/>
                              </div>
                            </div>
                          </ContentHolder>
                        </Col>
                      </Row>
                    ): null}

                    {this.state.changePassword ? (
                      <Row style={rowStyle}>
                        <button className="btn-savechanges" type="submit">保存</button>
                      </Row>
                    ): null}
                  </form>
                );
              }}/>
            
            <h2>
              <span>联络资讯</span>
              {this.state.primaryContactEditable ? null :
                <a href="javascript:void(0)" onClick={this.onClickPrimaryContactEdit}>修改</a>
              }
            </h2>
            <Formik
              initialValues={{
                accountId: this.state.profile && this.state.profile.email,
                password: '***********',
                firstName: '',
                lastName: '',
                countryCode: '+852',
                phone: '+852 ',
                email: this.state.profile && this.state.profile.email
              }}
              validate={values=>{}}
              onSubmit={values=>{
                console.log('edit primary contact')
                console.table(values)
                this.setState({
                  primaryContactEditable: false
                })
              }}
              render={({ handleSubmit, handleChange, handleBlur, setFieldValue, values, errors, dirty, touched}) => {
                return (
                  <form onSubmit={handleSubmit}>
                    <Row style={rowStyle}>
                      <Col md={12} sm={24} xs={24} style={colStyle}>
                        <ContentHolder>
                          <div className="inputWrapper">
                            <label htmlFor="firstName">昵称</label>

                            <div className={`FormTextInput ${!this.state.primaryContactEditable ? "noteditable" : ""}`}>
                              <input disabled={!this.state.primaryContactEditable} type="text" name="firstName" value={this.state.profile && this.state.profile.nickname} onChange={handleChange}/>
                            </div>
                          </div>
                        </ContentHolder>
                      </Col>
                      <Col md={12} sm={24} xs={24} style={colStyle}>
                        <ContentHolder>
                            <div className="inputWrapper" hidden>
                              <label htmlFor="lastName">Last Name</label>

                              <div className={`FormTextInput ${!this.state.primaryContactEditable ? "noteditable" : ""}`}>
                                <input disabled={!this.state.primaryContactEditable} type="text" name="lastName" value={values.lastName} onChange={handleChange}/>
                              </div>
                            </div>
                          </ContentHolder>
                      </Col>
                    </Row>

                    <Row style={rowStyle}>
                      <Col md={12} sm={24} xs={24} style={colStyle}>
                          <ContentHolder>
                            <div className="inputWrapper">
                              <label htmlFor="phone">联络电话</label>
                              <div className={`FormTextInput ${!this.state.primaryContactEditable ? "noteditable" : ""}`}>
                              <PhoneInput
                                country="HK"
                                disabled={!this.state.primaryContactEditable}
                                value={ values.phone }
                                onChange={ value => setFieldValue('phone', value) }/>
                                {/* <Dropdowns overlay={
                                  <DropdownMenu>
                                    <MenuItem>+852</MenuItem>
                                    <MenuItem>+852</MenuItem>
                                    <MenuItem>+852</MenuItem> 
                                  </DropdownMenu>}>
                                  <span className="ant-dropdown-link">
                                    +852 <Icon type="down" />
                                  </span>
                                </Dropdowns>
                                <input disabled={!this.state.primaryContactEditable} type="tel" name="phone" value={values.phone} onChange={handleChange}/> */}
                              </div>
                            </div>
                          </ContentHolder>
                      </Col>

                      <Col md={12} sm={24} xs={24} style={colStyle}>
                          <ContentHolder>
                            <div className="inputWrapper">
                              <label htmlFor="email">邮箱</label>

                              <div className={`FormTextInput ${!this.state.primaryContactEditable ? "noteditable" : ""}`}>
                                <input disabled={!this.state.primaryContactEditable} type="email" name="email" value={this.state.profile && this.state.profile.email} onChange={handleChange}/>
                              </div>
                            </div>
                          </ContentHolder>
                      </Col>
                    </Row>
                    {this.state.primaryContactEditable ? (
                      <Row style={rowStyle}>
                        <button className="btn-savechanges" type="submit">保存</button>
                      </Row>
                    ): null}
                  </form>
                );
              }}
            />
          </div>
        </div>
      </MyAccountWrapper>
    );
  }
}
function mapDispatchToProps(dispatch) {
  return { 
    setApp: (app) => dispatch(appSelected(app)),
    appSelected: bindActionCreators(appSelected, dispatch),
    searchTermUpdated:  bindActionCreators(searchTermUpdated, dispatch) ,

  }
}
function mapStateToProps(state) {
  const campaign  = state.get('campaign');
  return { 
    search: state.get('search'),
    campaign: campaign,
    currentApp: state.getIn( ['App', 'currentApp']),
    secondApp: state.getIn( ['App', 'secondApp']),
    searchTerm: state.getIn( ['App', 'searchTerm']),

  }
}



export default  connect(
  mapStateToProps,
  mapDispatchToProps
)(MyAccount);



// WEBPACK FOOTER //
// ./src/containers/MyAccount/index.js